// extracted by mini-css-extract-plugin
export default {"Item":"Post_Item__wCiu9","editItems":"Post_editItems__wmd+6","button":"Post_button__vomyL"};